const log = [{
  desc: '查询日志请求',
  options: {
    url: '/log/queryLog',
    method: 'post'
  }
}, {
  desc: '查询日志枚举',
  options: {
    url: '/log/testQueryDic',
    method: 'post'
  }
}, {
  desc: '查询业务日志',
  options: {
    url: '/log/getLog',
    method: 'post'
  }
}, {
  desc: '查询登录日志',
  options: {
    url: '/log/getCustomerLogin',
    method: 'post'
  }
}, {
  desc: '登录日志导出',
  options: {
    url: '/log/exportCustomerLogin',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '操作日志导出',
  options: {
    url: '/log/exportQueryLog',
    method: 'post',
    responseType: 'arraybuffer'
  }
}, {
  desc: '查询非车保单被保人变更记录',
  options: {
    url: '/log/queryInsuredChangeList',
    method: 'post'
  }
}, {
  desc: '查看接口获取IP地址区域信息',
  options: {
    url: '/log/getIpAddress',
    method: 'post'
  }
}]
export default log



// WEBPACK FOOTER //
// ./src/api/log.js